const RetryFetchData = ({ setRetry, onClick = null }) => (
  <>
    <button type="button" onClick={onClick ? () => onClick() : () => setRetry(false)} className="btn btn-warning inverted">
      Retry
    </button>
  </>
);

export default RetryFetchData;
